import Splide from '@splidejs/splide';

(() => {
  const popup = document.querySelector('.pdp-popup');
  if (!popup) return;

  const alsoConsider = document.querySelector('.js-alsoconsider');
  const defaultAlsoConsider = document.querySelector('.js-alsoconsider-default');

  const slider = popup.querySelector('.splide');
  const target = popup.querySelector('.splide__list');

  if (alsoConsider.querySelector('.productsrelated_container > *')) {
    const tiles = alsoConsider.querySelectorAll('.tile');
    tiles.forEach((tile) => {
      const slide = document.createElement('div');
      slide.classList.add('splide__slide');
      slide.appendChild(tile);
      target.appendChild(slide);
    });
  } else {
    const tiles = defaultAlsoConsider.querySelectorAll('.tile');
    tiles.forEach((tile) => {
      const slide = document.createElement('div');
      slide.classList.add('splide__slide');
      slide.appendChild(tile);
      target.appendChild(slide);
    });
  }

  new Splide(slider, {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    gap: '3vw',
    pagination: false,
    arrows: true,
    breakpoints: {
      1024: {
        perPage: 3,
      },
      768: {
        perPage: 2,
      },
      480: {
        perPage: 1,
      },
    },
  }).mount();

  const openPopup = () => {
    popup.classList.add('is-active');
  };

  const closePopup = () => {
    popup.classList.remove('is-active');
  };

  document.querySelectorAll('.catalog-single .product-shopping-actions .product-shopping-actions-addtocart button').forEach((btn) => {
    btn.addEventListener('click', openPopup);
  });

  popup.querySelector('.pdp-popup__close').addEventListener('click', closePopup);
})();
